// frontend/src/services/errorHandler.ts
import { AxiosError } from 'axios';
import { ApplicationError, ApiError } from '../types/error.types';

export class ErrorHandler {
  static async handleError(error: unknown): Promise<ApplicationError> {
    if (error instanceof ApplicationError) {
      return error;
    }

    if (error instanceof AxiosError) {
      return this.handleAxiosError(error);
    }

    return new ApplicationError(
      'UNKNOWN_ERROR',
      'An unexpected error occurred',
      500
    );
  }

  private static handleAxiosError(error: AxiosError): ApplicationError {
    const status = error.response?.status || 500;
    const data = error.response?.data as ApiError;

    switch (status) {
      case 401:
        return new ApplicationError(
          'UNAUTHORIZED',
          'Please login to continue',
          status
        );
      case 403:
        return new ApplicationError(
          'FORBIDDEN',
          'You do not have permission to perform this action',
          status
        );
      case 404:
        return new ApplicationError(
          'NOT_FOUND',
          'The requested resource was not found',
          status
        );
      case 422:
        return new ApplicationError(
          'VALIDATION_ERROR',
          'Invalid input data',
          status,
          data.details
        );
      default:
        return new ApplicationError(
          'SERVER_ERROR',
          'An unexpected server error occurred',
          status
        );
    }
  }
}